import React, {Component} from 'react'
import { fetchApi } from '@/utils/axios'

const REPORT_STAT_URL = '/user_action/users/analysis'

function find (str, cha, num) {
  let x = str.indexOf(cha)
  for (let i = 0; i < num; i++) {
    x = str.indexOf(cha, x + 1)
  }
  return x
}

// @description 为react组件提供页面停留时间统计的能力
// @params statData: 统计数据，json格式
// @params onReportSuccess(result): 统计上报回调事件
function YDStatistics (Wrapper) {
  return class StatistcsWrapper extends Component {
    constructor (props) {
      super(props)
      this.statistic = new Statistics()
      let index = find(document.location.pathname, '/', 1)
      let defaultStatData = {
        userData: {},
        refer: document.location.href,
        router: document.location.pathname.substring(index)
      }
      this.statistic.initStat(defaultStatData, this.reportStatistics)
    }

    reportStatistics = () => {
      let header = {
        'Content-type': 'application/json'
      }
      fetchApi({
        url: `${REPORT_STAT_URL}`,
        method: 'POST',
        data: this.statistic.getStat(),
        headers: header
      }).then(res => {
        this.onReportSuccess && this.onReportSuccess(res)
      }).catch((error) => {
        console.info(error)
      })
    }

    // 可选调用，不需要修改默认上报参数则可以不调用
    initStat = (statData, onReportSuccess) => {
      this.onReportSuccess = onReportSuccess
      this.statistic.initStat(statData, this.reportStatistics.bind(this))
    }

    componentDidMount () {
      this.statistic.enterPage()
    }

    componentWillUnmount () {
      this.statistic.exitPage()
    }

    render () {
      return (
        <Wrapper {...this.props} initStat={this.initStat.bind(this)}></Wrapper>
      )
    }
  }
}

// 统计的工具类
class Statistics {
  constructor (props) {
    this.props = props
    this.stat = {
      url: '', // 当前的url地址
      startTime: 0, // 进入页面时间
      endTime: 0, // 离开页面时间
      duration: 0, // 页面停留时长
      title: '', // 页面标题
      domain: '', // 域
      sh: 0, // 屏幕的高度
      sw: 0, // 屏幕的宽度
      language: '', // 当前语言
      refer: '', // 获取来源地址
      deviceType: 'WEB',
      router: '',
      userData: {} // 用户自定义统计数据
    }
    this.reportStatistics = null
  }

  initStat = (statData, reportStatistics) => {
    this.updateStat(statData, this.stat)
    this.reportStatistics = reportStatistics
  }

  updateStat = (newStat, oldStat) => {
    Object.entries(newStat).forEach((item) => {
      let key = item[0]
      let value = item[1]
      if (oldStat.hasOwnProperty(key)) {
        oldStat[key] = value
      }
    })
  }

  getStat = () => {
    return this.stat
  }

  // componentDidMount调用
  enterPage = () => {
    this.prestatitic()
    // 挂载浏览器回调事件，当浏览器关闭时触发调用。届时react的componentWillUnmount()不会生效
    window.onbeforeunload = this.onbeforeunload
  }

  // componentWillUnmount调用
  exitPage = () => {
    this.statistic()
    this.reportStatistics()
  }

  // 浏览器onload事件回调
  onload = () => {
    this.prestatitic()
  }

  // onbeforeunload 事件在即将离开当前页面（刷新或关闭）时触发
  onbeforeunload = () => {
    // 退出浏览器则退出登录
    let numbers = window.localStorage.getItem('numbers')
    const sesTime = window.sessionStorage.getItem('sesTime')
    const localTime = window.localStorage.getItem('localTime')
    // 当localTime 没有值，并且sesTime === localTime，减去当前页。
    if (localTime !== 'NaN' && localTime != null && sesTime === localTime) {
      numbers = parseInt(numbers, 10) - 1
      window.localStorage.setItem('numbers', numbers)
    }
    // 入参获取
    this.statistic()
    // 退出浏览器或标签页时请求
    this.reportStatistics()
  }

  prestatitic = () => {
    this.stat.startTime = (new Date()).valueOf()
    this.stat.title = document.title
    this.stat.domain = document.domain
    this.stat.language = navigator.language
  }

  statistic = () => {
    this.stat.endTime = (new Date()).valueOf()
    this.stat.duration = this.stat.endTime - this.stat.startTime
    this.stat.sh = window.screen.height
    this.stat.sw = window.screen.width
    this.stat.url = window.location.href
  }

  /**
   *获取网页来源的地址
  */
  getReferrer = () => {
    let referrer = ''
    try {
      referrer = window.top.document.referrer
    } catch (e) {
      if (window.parent) {
        try {
          referrer = window.parent.document.referrer
        } catch (e2) {
          referrer = ''
        }
      }
    }
    if (referrer === '') {
      referrer = document.referrer
    }
    return referrer
  }
}

export default YDStatistics
